(() => {
  if (customElements.get("two-image-parallax")) {
    return;
  }

  class TwoImageParallax extends HTMLElement {
    constructor() {
      super();
      gsap.registerPlugin(ScrollTrigger);
      this.parallax();
    }

    parallax() {
      if (window.innerWidth > 800) {
        this.querySelectorAll("[data-element-parallax]").forEach((item) => {
          const randomNumber = Math.random() * (200 - 0) + 0;

          const parallaxY =
            item.dataset.parallaxY !== undefined
              ? item.dataset.parallaxY
              : randomNumber;

          gsap.to(item, {
            y: - parallaxY,
            scrollTrigger: {
              trigger: item,
              start: "top 150%",
              end: "bottom 0%",
              scrub: 1,
            },
          });
        });
      }
    }
  }

  customElements.define("two-image-parallax", TwoImageParallax);
})();
